export function safeJson(s:string) {
  try {
    return JSON.parse(s);
  }
  catch(e) {
  }
}
